import { checkShouldHideQr, checkIsInrCurrency } from "utils/qrEligibility";

/**
 * Determines whether QR action button can be shown for a payment link record.
 * Handles case/whitespace-insensitive currency check and relies on checkShouldHideQr domain model.
 *
 * @param {Object} record - Payment link record
 * @param {Function} onShowQr - Callback function handler
 * @returns {boolean} True if QR button should be visible
 */
export const canShowQr = (record: any, onShowQr?: any) => {
  if (!onShowQr || typeof onShowQr !== "function") return false;
  const currency = record?.currency || record?.currency_name;
  if (!checkIsInrCurrency(currency)) return false;
  return !checkShouldHideQr({ offeringData: record });
};

export const noop = () => {};
